import React from 'react';
import { FcGoogle } from 'react-icons/fc';
import axios from 'axios';

const GoogleOAuthButton = ({ type = 'login' }) => {
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  const handleGoogleAuth = async () => {
    try {
      const endpoint = type === 'register' 
        ? `${API_BASE_URL}/auth/google/register-url`
        : `${API_BASE_URL}/auth/google/login-url`;
      
      const response = await axios.get(endpoint);
      window.location.href = response.data.url;
    } catch (error) {
      console.error('Google auth error:', error);
      alert(`Failed to initiate Google ${type}. Please try again.`);
    }
  };

  return (
    <button
      onClick={handleGoogleAuth}
      className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
    >
      <FcGoogle className="text-2xl" />
      <span className="text-gray-700 font-medium">
        {type === 'login' ? 'Continue with Google' : type === 'register' ? 'Register with Google' : 'Sign up with Google'}
      </span>
    </button>
  );
};

export default GoogleOAuthButton;
